import React from 'react'
import { Box } from '@mui/material'
import Slider from 'react-slick'
import { Trans, useTranslation } from 'react-i18next'
import { TakeItFromHappyMembersCard } from './TakeItFromHappyMembersCard'
import SangBleu from '../../../frontend-lib/typhograpy/SangBleu'
import { useIsMd } from '../../../theme/useIsMd'

export function TakeItFromHappyMembersSection({ carouselSettings, quotes }) {
  const { t } = useTranslation()
  const isMd = useIsMd()

  return (
    <Box
      sx={{
        pt: 10,
        display: 'flex',
        alignItems: 'left',
        flexDirection: 'column',
        backgroundColor: 'white',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          maxWidth: { md: '60%', xs: '100%' },
          ml: { lg: 16, md: 8, xs: 3, sm: 5 },
        }}
      >
        <SangBleu size={isMd ? 56 : 40} color="mono.black">
          <Trans i18nKey="takeItFromHappyMembers.title">
            <SangBleu component="span" size={isMd ? 56 : 40} color="#6665DD">
              {t('takeItFromHappyMembers.thousands')}
            </SangBleu>
          </Trans>
        </SangBleu>
      </Box>
      <Box
        sx={{ py: 6, width: '100%', overflow: 'hidden', pl: { md: 5, sm: 3 } }}
      >
        <Slider {...carouselSettings}>
          {quotes.map((quote) => (
            <Box key={quote.name.replaceAll(' ', '')}>
              <TakeItFromHappyMembersCard {...quote} />
            </Box>
          ))}
        </Slider>
      </Box>
    </Box>
  )
}
